<template>
<div class="view-port clearfix" id="alerts">
  <!-- BEGIN Alerts View !-->
  <div class="view bg-white">
    <!-- BEGIN View Header !-->
    <div class="navbar navbar-default navbar-sm">
      <div class="navbar-inner">
        <!-- BEGIN Header Controler !-->
        <a href="javascript:;" class="inline action p-l-10 link text-master" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
          <i class="pg-more"></i>
        </a>
        <!-- END Header Controler !-->
        <div class="view-heading">
          Notications
        </div>
        <!-- BEGIN Header Controler !-->
        <a href="#" class="inline action p-r-10 pull-right link text-master">
          <i class="pg-search"></i>
        </a>
        <!-- END Header Controler !-->
      </div>
    </div>
    <!-- END View Header !-->
    <!-- BEGIN Alert List !-->
    <div data-init-list-view="ioslist" class="list-view boreded no-top-border">
      <!-- BEGIN List Group !-->
      <div class="list-view-group-container">
        <!-- BEGIN List Group Header!-->
        <div class="list-view-group-header text-uppercase">
          Calendar
        </div>
        <!-- END List Group Header!-->
        <ul>
          <!-- BEGIN List Group Item!-->
          <li class="alert-list">
            <!-- BEGIN Alert Item Set Animation using data-view-animation !-->
            <a href="javascript:;" class="" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
              <p class="col-xs-height col-middle">
                <span class="text-warning fs-10"><i class="fa fa-circle"></i></span>
              </p>
              <p class="p-l-10 col-xs-height col-middle col-xs-9 overflow-ellipsis fs-12">
                <span class="text-master">David Nester Birthday</span>
              </p>
              <p class="p-r-10 col-xs-height col-middle fs-12 text-right">
                <span class="text-warning">Today <br></span>
                <span class="text-master">All Day</span>
              </p>
            </a>
            <!-- END Alert Item!-->
            <!-- BEGIN List Group Item!-->
          </li>
          <!-- END List Group Item!-->
          <!-- BEGIN List Group Item!-->
          <li class="alert-list">
            <!-- BEGIN Alert Item Set Animation using data-view-animation !-->
            <a href="#" class="" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
              <p class="col-xs-height col-middle">
                <span class="text-warning fs-10"><i class="fa fa-circle"></i></span>
              </p>
              <p class="p-l-10 col-xs-height col-middle col-xs-9 overflow-ellipsis fs-12">
                <span class="text-master">Meeting at 2:30</span>
              </p>
              <p class="p-r-10 col-xs-height col-middle fs-12 text-right">
                <span class="text-warning">Today</span>
              </p>
            </a>
            <!-- END Alert Item!-->
          </li>
          <!-- END List Group Item!-->
        </ul>
      </div>
      <!-- END List Group !-->
      <div class="list-view-group-container">
        <!-- BEGIN List Group Header!-->
        <div class="list-view-group-header text-uppercase">
          Social
        </div>
        <!-- END List Group Header!-->
        <ul>
          <!-- BEGIN List Group Item!-->
          <li class="alert-list">
            <!-- BEGIN Alert Item Set Animation using data-view-animation !-->
            <a href="javascript:;" class="p-t-10 p-b-10" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
              <p class="col-xs-height col-middle">
                <span class="text-complete fs-10"><i class="fa fa-circle"></i></span>
              </p>
              <p class="p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12">
                <span class="text-master link">Jame Smith commented on your status<br></span>
                <span class="text-master">“Perfection Simplified - Company Revox"</span>
              </p>
            </a>
            <!-- END Alert Item!-->
          </li>
          <!-- END List Group Item!-->
          <!-- BEGIN List Group Item!-->
          <li class="alert-list">
            <!-- BEGIN Alert Item Set Animation using data-view-animation !-->
            <a href="javascript:;" class="p-t-10 p-b-10" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
              <p class="col-xs-height col-middle">
                <span class="text-complete fs-10"><i class="fa fa-circle"></i></span>
              </p>
              <p class="p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12">
                <span class="text-master link">Jame Smith commented on your status<br></span>
                <span class="text-master">“Perfection Simplified - Company Revox"</span>
              </p>
            </a>
            <!-- END Alert Item!-->
          </li>
          <!-- END List Group Item!-->
        </ul>
      </div>
      <div class="list-view-group-container">
        <!-- BEGIN List Group Header!-->
        <div class="list-view-group-header text-uppercase">
          Sever Status
        </div>
        <!-- END List Group Header!-->
        <ul>
          <!-- BEGIN List Group Item!-->
          <li class="alert-list">
            <!-- BEGIN Alert Item Set Animation using data-view-animation !-->
            <a href="#" class="p-t-10 p-b-10" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
              <p class="col-xs-height col-middle">
                <span class="text-danger fs-10"><i class="fa fa-circle"></i></span>
              </p>
              <p class="p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12">
                <span class="text-master link">12:13AM GTM, 10230, ID:WR174s<br></span>
                <span class="text-master">Server Load Exceeted. Take action</span>
              </p>
            </a>
            <!-- END Alert Item!-->
          </li>
          <!-- END List Group Item!-->
        </ul>
      </div>
    </div>
    <!-- END Alert List !-->
  </div>
  <!-- EEND Alerts View !-->
</div>
</template>

<script>
  export default {
    name: "Alerts"
  }
</script>


// WEBPACK FOOTER //
// alerts.vue?08bf8a8b